import client from "./client";

const uploadsApi = {
  uploadFile(folder, file, onProgress) {
    const formData = new FormData();
    formData.append("file", file);

    return client
      .post(`/uploads/${folder}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: onProgress
          ? (e) => onProgress(Math.round((e.loaded * 100) / (e.total || 1)))
          : undefined,
      })
      .then((r) => r.data);
  },

  uploadMultiple(folder, files, onProgress) {
    const formData = new FormData();
    files.forEach((f) => formData.append("files", f));

    return client
      .post(`/uploads/${folder}/multiple`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: onProgress
          ? (e) => onProgress(Math.round((e.loaded * 100) / (e.total || 1)))
          : undefined,
      })
      .then((r) => r.data);
  },

  deleteFile(key) {
    return client.delete("/uploads", { data: { key } }).then((r) => r.data);
  },

  getPresignedUrl(key) {
    return client.get("/uploads/presigned", { params: { key } }).then((r) => r.data);
  },
};

export default uploadsApi;
